import * as prod from './app.prod';
import * as stage from './app.stage';
import * as local from './app.dev';

export type AppEnv = 'prod' | 'stage' | 'local';

const mode = import.meta.env.MODE;
const selected = mode === 'production' ? prod : mode === 'staging' ? stage : local;

export const APP_ENV: AppEnv = selected.APP_ENV;
export const APP_VERSION = selected.APP_VERSION;
export const RELEASE_NOTES = selected.RELEASE_NOTES;
